import {combineEpics} from 'redux-observable';
import {makeAsyncEpic} from 'common/utils/simplifiedAsync';
import * as api from '../services/api';
import * as actions from './actions';

const fetchDnsTrackerData = makeAsyncEpic(actions.fetchDnsTrackerData, api.fetchDnsTrackerData);

export default combineEpics(fetchDnsTrackerData);
